import * as React from 'react';
import { ModelAction } from '../../../../types/responses/ModelAction';
import { ProjectDocFolder } from '../../models/ProjectDocFolder';
import { ProjectDocFolderTreeNode } from '../../models/ProjectDocFolderTreeNode';
import { PaperSigningActions } from '../../../../components/shared/PaperSigningActions';
import { PaperSigningTab } from './PaperSigningTab';
import { ScrollContainer } from '../../../../components/shared/ScrollContainer';
import { services } from '../../../../services';
import { useBackgroundPromiseWrapper } from '../../../../helpers/hooks/useBackgroundPromiseWrapper';

interface PaperSigningTabPanelProps {
    projectDocId: number;
    onProjectDocStatusUpdated: () => void;
    selectedSlotId?: number;
    onSelectSlot: (slot: ProjectDocFolder | undefined) => void;
}

export interface PaperSigningTabPanelRef {
    loadActions: () => void;
}

export const PaperSigningTabPanel = React.forwardRef<PaperSigningTabPanelRef, PaperSigningTabPanelProps>(
    ({ projectDocId, onProjectDocStatusUpdated, selectedSlotId, onSelectSlot }, ref) => {
        const [promiseWrapper] = useBackgroundPromiseWrapper();
        const [actions, setActions] = React.useState<ModelAction[]>([]);

        const loadActions = React.useCallback(() => {
            if (projectDocId === 0) return;
            promiseWrapper(
                () => services.projectDocService.actions(projectDocId),
                (res: ModelAction[]) => setActions(res),
            );
        }, [promiseWrapper, projectDocId]);

        React.useEffect(loadActions, [projectDocId]);

        React.useImperativeHandle(ref, () => ({ loadActions }), [loadActions]);

        const handleSelectSlot = (node: ProjectDocFolderTreeNode) => {
            onSelectSlot(node.data);
        };

        return (
            <React.Fragment>
                <div className="pd-structure-actions">
                    <PaperSigningActions
                        projectDocId={projectDocId}
                        onProjectDocStatusUpdated={onProjectDocStatusUpdated}
                        actions={actions}
                        loadActions={loadActions}
                    />
                </div>
                <ScrollContainer useWrapper={true}>
                    <PaperSigningTab
                        projectDocId={projectDocId}
                        selectedSlotId={selectedSlotId}
                        onSelectSlot={handleSelectSlot}
                    />
                </ScrollContainer>
            </React.Fragment>
        );
    }
);
